import { isEmpty } from "lodash";
import React, { useContext, useRef, useState, useEffect } from "react";

import BetSlipContext from "../../context/BetSlipContext";

const BackandLay = ({
  back,
  lay,
  item,
  details,
  setSelectedBet,
  setKey,
  setSlipObj,
  slipObj,
  handelBetFairPositions,
  handelBookmakerPositions,
  setCondi,
  betType,
  betmode,
  amountRange,
  index,
  market,
  resetSelection,
  messaageBox,
  disabelBack,
  disabelLay,
  marketName,
  bookmakerObj
}) => {

  let { betSelectionObj, setBetSelectionObj, defaultStake, defaultOdds } =
    useContext(BetSlipContext);
  const myRef = useRef(null);
  const [id, setId] = useState({
    index: "",
    id: "",
    type: "",
  });

  // Track previous values for spark animation
  const prevBackBv = useRef(null);
  const prevBackRt = useRef(null);
  const prevLayBv = useRef(null);
  const prevLayRt = useRef(null);
  const [sparkBack, setSparkBack] = useState(false);
  const [sparkLay, setSparkLay] = useState(false);

  // Update spark animation when back odds change
  useEffect(() => {
    const currentBackBv = back[0]?.bv;
    const currentBackRt = back[0]?.rt;

    if (
      (prevBackBv.current !== null && prevBackBv.current !== currentBackBv) ||
      (prevBackRt.current !== null && prevBackRt.current !== currentBackRt)
    ) {
      setSparkBack(true);
      setTimeout(() => setSparkBack(false), 500);
    }

    prevBackBv.current = currentBackBv;
    prevBackRt.current = currentBackRt;
  }, [back[0]?.bv, back[0]?.rt]);

  // Update spark animation when lay odds change
  useEffect(() => {
    const currentLayBv = lay[0]?.bv;
    const currentLayRt = lay[0]?.rt;

    if (
      (prevLayBv.current !== null && prevLayBv.current !== currentLayBv) ||
      (prevLayRt.current !== null && prevLayRt.current !== currentLayRt)
    ) {
      setSparkLay(true);
      setTimeout(() => setSparkLay(false), 500);
    }

    prevLayBv.current = currentLayBv;
    prevLayRt.current = currentLayRt;
  }, [lay[0]?.bv, lay[0]?.rt]);

  const handleScroll = () => {
    setId({
      index: "",
      id: "",
      type: "",
    });
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const handle = () => {
    myRef?.current?.scrollIntoView();
  };
  useEffect(() => {
    handle();
  }, [id]);

  const backOdd = () => {
    if (betType === "bookmaker") {
      if (back[0]?.ms == 1) {
        return back[0]?.rt;
      } else {
        return null;
      }
    } else {
      return back[0]?.rt;
    }
  };
  const backOddSpan = () => {
    if (betType === "bookmaker") {
      // if (back[0]?.ms == 1) {
      //   return back[0]?.bv;
      // } else {
      return null;
      // }
    } else {
      return back[0]?.bv;
    }
  };

  const layOdd = () => {
    if (betType === "bookmaker") {
      if (lay[0]?.ms == 1) {
        return lay[0]?.rt;
      } else {
        return null;
      }
    } else {
      return lay[0]?.rt;
    }
  };
  const layOddSpan = () => {
    if (betType === "bookmaker") {
      // if (lay[0]?.ms == 1) {
      //   return lay[0]?.bv;
      // } else {
      return null;
      //}
    } else {
      return lay[0]?.bv;
    }
  };
  return (
    <>
      <dd
        id="back_1"
        onClick={() => {
          if (betType === "bookmaker" && Number(back[0]?.ms) !== 1) {
          } else {
            if (back[0]?.rt !== null && market == "") {
              if (
                back?.length === 0 ||
                betmode == "off" ||
                details?.sport_setting?.status == "inActive"
              ) {
              } else {
                if (
                  Number(back[0]?.rt) == undefined ||
                  Number(back[0]?.rt) > amountRange?.oddsLimit
                ) {
                } else {
                  if (betType == "betFair" && disabelBack) {
                  } else {
                    if (amountRange?.oddsLimit !== 0) {
                      if (!messaageBox) {
                        if (betSelectionObj.betType !== betType) {
                          resetSelection(betSelectionObj.betType);
                        }
                        setKey(item?.SelectionId);
                        setId({
                          index: index,
                          id: item?.SelectionId,
                          type: betType,
                        });
                        setBetSelectionObj({
                          ...betSelectionObj,
                          betType: betType,
                          oddsSelect: back[0]?.rt,
                          layorback: "back",
                          bidPrice: defaultStake == 0 ? "" : defaultStake,
                          inputType: "price",
                          priceToogle: true,
                          priceToogleType: "odds",
                          expectany: defaultOdds,
                          gameType: details?.gameType,
                          minAmount: amountRange?.min,
                          maxAmount: amountRange?.max,
                          bmi: bookmakerObj?.bmi,
                        });
                        if (
                          betType == "tie" &&
                          slipObj?.SelectionId == item?.SelectionId &&
                          betSelectionObj?.layorback == "back"
                        ) {
                          handelBetFairPositions({
                            ...item,
                            ...back[0],
                            teamName: item?.RunnerName,
                            ...details,
                          });
                        } else if (
                          betType == "betFair" &&
                          slipObj?.SelectionId == item?.SelectionId &&
                          betSelectionObj?.layorback == "back"
                        ) {
                          handelBetFairPositions({
                            ...item,
                            ...back[0],
                            teamName: item?.RunnerName,
                            ...details,
                          });
                        } else if (
                          betType == "bookmaker" &&
                          slipObj?.SelectionId == item?.SelectionId &&
                          betSelectionObj?.layorback == "back"
                        ) {
                          handelBookmakerPositions({
                            ...item,
                            ...back[0],
                            teamName: item?.RunnerName,
                            ...details,
                          });
                        }
                        setSlipObj({
                          ...item,
                          ...back[0],
                          teamName: item?.RunnerName,
                          ...details,
                        });
                        setSelectedBet({
                          selectionId: item?.SelectionId,
                          teamName: item?.RunnerName,
                          check: "back",
                          sid: item?.sid
                        });
                      }
                    }
                  }
                }
              }
            }
          }
        }}
        style={
          back?.length === 0 ||
          betmode == "off" ||
          details?.sport_setting?.status == "inActive"
            ? { cursor: "not-allowed" }
            : { cursor: "pointer" }
        }
        className={
          back[0]?.rt == undefined ||
          back[0]?.rt == 0 ||
          details?.sport_setting?.status == "inActive"
            ? "single-disabled"
            : back[0]?.rt > amountRange?.oddsLimit
            ? "single-disabled"
            : betType == "betFair" && disabelBack
            ? "single-disabled"
            : ""
        }
      >
        <a
          ref={
            index == id.index &&
            betType == id.type &&
            (betType == "bookmaker" ? item?.selectionID : item?.SelectionId) ==
              id.id
              ? myRef
              : null
          }
          name={back[0]?.bv}
          title={back[0]?.rt}
          id={"back_odds_" + index}
          className={
            slipObj?.teamName ==
              (betType == "betFair" ? item?.RunnerName : item?.runnerName) &&
            betSelectionObj?.layorback == "back" &&
            betSelectionObj.betType == betType &&
            betSelectionObj?.priceToogle
              ? `back-1 select ${sparkBack ? "spark" : ""}`
              : `back-1 ${sparkBack ? "spark" : ""}`
          }
          href="javascript:void(0)"
        >
          {backOdd()}
          <span>{backOddSpan()}</span>
        </a>
      </dd>
      <dd
        id="lay_1"
        onClick={() => {
          if (betType === "betFair" && marketName == "To Win the Toss") {
          } else {
            if (betType === "bookmaker" && Number(lay[0]?.ms) !== 1) {
            } else {
              if (lay[0]?.rt !== null && market == "") {
                if (
                  lay?.length === 0 ||
                  betmode == "off" ||
                  details?.sport_setting?.status == "inActive"
                ) {
                } else {
                  if (
                    Number(lay[0]?.rt) == undefined ||
                    Number(lay[0]?.rt) > amountRange?.oddsLimit
                  ) {
                  } else {
                    if (betType == "betFair" && disabelLay) {
                    } else {
                      if (!messaageBox) {
                        if (betSelectionObj.betType !== betType) {
                          resetSelection(betSelectionObj.betType);
                        }
                        setKey(item?.SelectionId);
                        setId({
                          index: index,
                          id: item?.SelectionId,
                          type: betType,
                        });
                        setBetSelectionObj({
                          ...betSelectionObj,
                          betType: betType,
                          oddsSelect: lay[0]?.rt,
                          layorback: "lay",
                          bidPrice: defaultStake == 0 ? "" : defaultStake,
                          priceToogle: true,
                          priceToogleType: "odds",
                          gameType: details?.gameType,
                          minAmount: amountRange?.min,
                          maxAmount: amountRange?.max,
                          expectany: defaultOdds,
                          inputType: "price",
                          bmi: bookmakerObj?.bmi,
                        });
                        if (
                          betType == "tie" &&
                          slipObj?.SelectionId == item?.SelectionId &&
                          betSelectionObj?.layorback !== "lay"
                        ) {
                          setCondi(true);
                          handelBetFairPositions({
                            ...item,
                            ...lay[0],
                            teamName: item?.RunnerName,
                            ...details,
                          });
                        } else if (
                          betType == "betFair" &&
                          slipObj?.SelectionId == item?.SelectionId &&
                          betSelectionObj?.layorback !== "lay"
                        ) {
                          setCondi(true);
                          handelBetFairPositions({
                            ...item,
                            ...lay[0],
                            teamName: item?.RunnerName,
                            ...details,
                          });
                        } else if (
                          betType == "bookmaker" &&
                          slipObj?.SelectionId == item?.SelectionId &&
                          betSelectionObj?.layorback !== "lay"
                        ) {
                          handelBookmakerPositions({
                            ...item,
                            ...back[0],
                            teamName: item?.RunnerName,
                            ...details,
                          });
                        }
                        setSlipObj({
                          ...item,
                          ...lay[0],
                          teamName: item?.RunnerName,
                          ...details,
                        });
                        setSelectedBet({
                          selectionId: item?.SelectionId,
                          teamName: item?.RunnerName,
                          check: "lay",
                        });
                      }
                    }
                  }
                }
              }
            }
          }
        }}
        className={
          betType === "betFair" && marketName == "To Win the Toss"
            ? "single-disabled"
            : lay[0]?.rt == undefined ||
              lay[0]?.rt == 0 ||
              details?.sport_setting?.status == "inActive"
            ? "single-disabled"
            : lay[0]?.rt > amountRange?.oddsLimit
            ? "single-disabled"
            : ""
        }
        style={
          betType === "betFair" && marketName == "To Win the Toss"
            ? { cursor: "not-allowed" }
            : lay?.length === 0 ||
              betmode == "off" ||
              details?.sport_setting?.status == "inActive"
            ? { cursor: "not-allowed" }
            : { cursor: "pointer" }
        }
      >
        <a
          ref={
            index == id.index &&
            betType == id.type &&
            (betType == "bookmaker" ? item?.selectionID : item?.SelectionId) ==
              id.id
              ? myRef
              : null
          }
          id={"lay_odds_" + index}
          name={lay[0]?.bv}
          title={lay[0]?.rt}
          className={
            slipObj?.teamName ==
              (betType == "betFair" ? item?.RunnerName : item?.runnerName) &&
            betSelectionObj?.layorback == "lay" &&
            betSelectionObj.betType == betType &&
            betSelectionObj?.priceToogle
              ? `lay-1 select ${sparkLay ? "spark" : ""}`
              : `lay-1 ${sparkLay ? "spark" : ""}`
          }
          href="javascript:void(0)"
        >
          {layOdd()}
          <span>{layOddSpan()}</span>
        </a>
      </dd>
    </>
  );
};

export default BackandLay;
